var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SplashScaffold',[_c('div',{staticClass:"ow-center-content ow-fill"},[_vm._v(" "+_vm._s(_vm.$t('error.404'))+" ")]),_c('div',{staticClass:"ow-main-content"},[_c('div',{staticClass:"ow-fill"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }